import { AdvanceOrderStatus } from "./AdvanceOrderStatus.enum";
import { Branch } from "./Branch.type";
import { CardTransaction } from "./CardTransaction.type";
import { CostCenter } from "./CostCenter.type";
import { JudgementStatus } from "./JudgementStatus.enum";
import { Phase } from "./Phase.type";
import { Project } from "./Project.type";
import { ReasonExpense } from "./ReasonExpense.type";
import type { Traveler } from "./Traveler.type";
import type { ExpenseCard } from "./ExpenseCard.type";
export enum PixKeyType {
  CPF = "cpf",
  CNPJ = "cnpj",
  PHONE = "phone",
  EMAIL = "email",
  EVP = "evp",
}

export type ApproverAdvance = {
  uuid: string;
  name: string;
  level: number;
  approvalStatus: JudgementStatus;
  isSelfApprover: boolean;
};

export type TravelerAdvance = {
  uuid: string;
  order?: {
    uuid?: string;
    orderNumber?: number;
    travelers?: Traveler[];
  };
  advanceNumber: number;
  createdAt: string;
  traveler: Partial<Traveler> | null;
  description: string;
  currentApprover?: string;
  issuer: { uuid: string; name: string };
  costCenter?: Partial<CostCenter>;
  project?: Partial<Project>;
  phase?: Partial<Phase>;
  branch?: Partial<Branch> | null;
  reasonExpense?: Partial<ReasonExpense>;
  status: AdvanceOrderStatus;
  approvalRequestDate?: string;
  approvalModel?: {
    approvers?: ApproverAdvance[];
    uuid: string;
  };
  expenses?: { createdAt: Date; value: number }[];
  approvedBy?: string;
  value: number;
  dateOfNeed: Date;
  paymentReceiptUrl?: string;
  reasonRejected?: string;
  cardTransactions?: CardTransaction[];
  cardId?: string;
  card?: ExpenseCard;
  pixKey?: string;
  pixType?: PixKeyType;
  bankInstitution?: string;
  cardTransaction: CardTransaction | null;
};
export type OrderAdvance = {
  orderId?: string | null;
  travelers: TravelerAdvance[];
};
